var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field__content"},[(_vm.val.poi !== '' && _vm.val.name !== '')?[_c('a-button',{staticStyle:{"padding-left":"0"},attrs:{"type":"link","target":"_blank","href":`/#/order/orderlist_b?poiId=${_vm.val.poi}&shopName=${_vm.val.name}`}},[_vm._v("点击跳转")])]:[_vm._v("无")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }